export type TabId =
  | 'twitter'
  | 'gmail'
  | 'discord'
  | 'kalender'
  | 'suno'
  | 'twitch'
  | 'youtube'

export interface TabConfig {
  id: TabId
  label: string
  type: 'external' | 'calendar'
  url?: string
  icon: string
}

export const TABS: TabConfig[] = [
  {
    id: 'twitter',
    label: 'Twitter',
    type: 'external',
    url: 'https://x.com',
    icon: '𝕏',
  },
  {
    id: 'gmail',
    label: 'GMail',
    type: 'external',
    url: 'https://mail.google.com',
    icon: '✉',
  },
  {
    id: 'discord',
    label: 'Discord',
    type: 'external',
    url: 'https://discord.com/app',
    icon: '◈',
  },
  {
    id: 'kalender',
    label: 'Kalender',
    type: 'calendar',
    icon: '▣',
  },
  {
    id: 'suno',
    label: 'Suno',
    type: 'external',
    url: 'https://suno.com',
    icon: '♪',
  },
  {
    id: 'twitch',
    label: 'Twitch',
    type: 'external',
    url: 'https://www.twitch.tv',
    icon: '▶',
  },
  {
    id: 'youtube',
    label: 'YouTube',
    type: 'external',
    url: 'https://www.youtube.com',
    icon: '▷',
  },
]

export const STORAGE_KEY = 'neon-deck-events'
export const SETTINGS_KEY = 'neon-deck-settings'

export const EVENT_COLORS = [
  '#00f0ff',
  '#ff2bd6',
  '#a855f7',
  '#22c55e',
  '#f59e0b',
  '#ef4444',
] as const
